import { getAllowedCategoriesForPermission } from "@/hooks/utils";
import { useAppSelector } from "@/store/hooks";
import { Dispatch, SetStateAction } from "react";
import DynamicCategorySelector from "../DynamicCategorySelector";
import { CodesLessonsAndCatsI } from "./EditCode";

const CodeLessonsAndCats = ({
  type,
  itemType,
  title,
  items,
  setItems,
}: {
  type: "included" | "excluded";
  itemType: "category" | "lesson";
  title: string;
  items: CodesLessonsAndCatsI;
  setItems: Dispatch<SetStateAction<CodesLessonsAndCatsI>>;
}) => {
  const { userProfileData, portal } = useAppSelector((state) => state.store);

  // const getTitle = (el: CodesLessonsAndCatsI[keyof CodesLessonsAndCatsI]) => {
  //   return decodeURIComponent(el.title?.split("|")[0]);
  // };

  // const getCatOrCatType = (
  //   el: CodesLessonsAndCatsI[keyof CodesLessonsAndCatsI]
  // ) => {
  //   return decodeURIComponent(
  //     el.hasOwnProperty("parent")
  //       ? el.parent
  //         ? "قسم فرعي"
  //         : "قسم رئيسي"
  //       : el.slug
  //           .replace(userProfileData?.teacher_prefix ?? "", "")
  //           .replace(/-/g, " ")
  //   );
  // };

  const allowedCats = getAllowedCategoriesForPermission("can_create_codes");
  const alreadyChosenLessons = Object.values({ ...items }).map((el) => {
    if (el.included || el.excluded) {
      return el.id;
    }
  });

  const cats = allowedCats
    ? portal?.cats?.filter((cat) => allowedCats.includes(cat.term_id))
    : portal?.cats || [];

  const lessons = allowedCats
    ? portal?.data?.filter((lesson) =>
        allowedCats?.includes(Number(lesson.term_taxonomy_id))
      )
    : portal?.data || [];

  return (
    <>
      {/* <select
        className="border border-gray-300 rounded-md p-2 w-3/4 mb-2 focus:outline-none focus:ring-2 focus:ring-primary"
        aria-label="Default select example"
        value={title}
        onChange={(e) =>
          setItems({
            ...items,
            [e.target.value]: {
              ...items[e.target.value],
              [type]: true,
            },
          })
        }
      >
        <option value="" selected>
          {title}
        </option>
        {Object.values(items ?? {})
          ?.filter((el) => !el.included && !el.excluded)
          .map((item) => (
            <option value={item.id}>
              {getTitle(item)} - {getCatOrCatType(item)}
            </option>
          ))}
      </select> */}

      <div className="md:w-3/4 w-full">
        <label className="block mb-2 text-primary font-semibold">{title}</label>
        <DynamicCategorySelector
          showConfirmSelectionBtn={true}
          confirmSelectionBtnText={
            itemType === "lesson" ? "أضف الحصة" : "أضف القسم"
          }
          showLessonsSelector={itemType === "lesson"}
          filteredCats={cats}
          filteredLessons={lessons.filter(
            (el) => !alreadyChosenLessons.includes(el.ID)
          )}
          excludeCatsThatHasLessons={false}
          confirmSelectionHandlerFunction={(value, itemType, chosenCatsIds) => {
            if (!value?.id) return;
            setItems((prev: CodesLessonsAndCatsI) => ({
              ...prev,
              [value?.id]: {
                ...(value as unknown as CodesLessonsAndCatsI[keyof CodesLessonsAndCatsI]),
                included: false,
                excluded: false,
                [type]: true,
              },
            }));
          }}
        />
      </div>

      <div className="my-2 flex" style={{ flexWrap: "wrap" }}>
        {Object.values(items ?? {})
          ?.filter((el) => el[type])
          .map((el) => (
            <span
              key={el.id}
              className={`${
                type === "excluded"
                  ? "bg-red-100 border border-red-400"
                  : "bg-green-100 border border-green-400"
              } py-1 px-2 rounded-md m-1`}
              style={{ cursor: "pointer", minWidth: "fit-content" }}
              onClick={() => {
                setItems({
                  ...items,
                  [el.id]: { ...el, [type]: false },
                });
              }}
            >
              {el.title}
              <i
                className="bi bi-x-circle-fill"
                style={{ marginRight: "5px" }}
              ></i>
            </span>
          ))}
      </div>
    </>
  );
};

export default CodeLessonsAndCats;
